import { Component, ElementRef, HostListener, inject, Input, ViewChild } from "@angular/core";
import { Menu } from "./menu/menu";
import { UserInfo } from "./user-info/user-info";
import { MatIcon } from "@angular/material/icon";
import { UmbracoIndstillinger } from "@e-forsyning/common/umbraco-indstillinger";
import { Bruger } from "@e-forsyning/common/bruger";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ThemeMode, ThemeService, SvgIconRegistry } from "@dffedb/util";
import { mdiCheck, mdiChevronDown, mdiChevronRight, mdiPalette } from "@mdi/js";

@Component({
    selector: "top-navigation",
    imports: [Menu, UserInfo, MatIcon, RouterLink, RouterLinkActive],
    templateUrl: "./top-navigation.html",
    styleUrl: "./top-navigation.scss"
})
export class TopNavigation {
    @Input()
    public indstillinger: UmbracoIndstillinger;

    @Input()
    public aktuelBruger: Bruger | null = null;

    @Input()
    public menuItems: { label: string; icon: string; route: string; id?: string }[] = [];

    @ViewChild("burgerButton") private readonly burgerButton!: ElementRef<HTMLButtonElement>;

    public showMenu: boolean = false;
    public showInfo: boolean = false;
    public showThemeSubmenu: boolean = false;
    public userInfoData: any;

    private readonly themeService = inject(ThemeService);
    public readonly themeOptions = this.themeService.getThemeOptions();
    public readonly activeTheme = this.themeService.activeTheme;

    constructor(
        private elementRef: ElementRef,
        svgIconRegistry: SvgIconRegistry
    ) {
        svgIconRegistry.registerIcon(mdiPalette, "menu-theme");
        svgIconRegistry.registerIcon(mdiChevronRight, "chevron-right");
        svgIconRegistry.registerIcon(mdiChevronDown, "chevron-down");
        svgIconRegistry.registerIcon(mdiCheck, "check");
    }
    @HostListener("document:click", ["$event"])
    public onDocumentClick(event: MouseEvent): void {
        if (this.showMenu && !this.elementRef.nativeElement.contains(event.target)) {
            this.showMenu = false;
            this.showThemeSubmenu = false;
        }
    }

    ngOnInit(): void {
        const initialer = (this.aktuelBruger?.initialer || "").trim();
        this.userInfoData = {
            user: {
                initialer,
                name: this.aktuelBruger ? this.aktuelBruger.navn : "",
                email: this.aktuelBruger ? this.aktuelBruger.email : ""
            },
            works: {
                name: this.indstillinger ? this.indstillinger.firmaNavn : "",
                phone:
                    this.indstillinger && this.indstillinger.forsyningWeb.firmaInfo && this.indstillinger.forsyningWeb.firmaInfo.telefon
                        ? this.indstillinger.forsyningWeb.firmaInfo.telefon
                        : ""
            }
        };
    }

    @HostListener("document:keydown.escape")
    public onEscape(): void {
        if (this.showMenu) {
            this.closeAndFocus();
        }
    }

    public toggleMenu(): void {
        this.showMenu = !this.showMenu;
        if (!this.showMenu) {
            this.showThemeSubmenu = false;
        }
        if (this.showMenu) {
            setTimeout(() => {
                const firstItem = document.querySelector<HTMLElement>('#user-dropdown-menu [role="menuitem"]');
                firstItem?.focus();
            });
        }
    }

    public closeAndFocus(): void {
        this.showMenu = false;
        this.showThemeSubmenu = false;
        setTimeout(() => this.burgerButton?.nativeElement?.focus());
    }

    public toggleThemeSubmenu(): void {
        this.showThemeSubmenu = !this.showThemeSubmenu;
    }

    public selectTheme(mode: ThemeMode): void {
        this.themeService.setTheme(mode, true);
    }

    public openInfo(): void {
        this.showMenu = false;
        this.showThemeSubmenu = false;
        this.showInfo = true;
    }

    public closeInfo(): void {
        this.showInfo = false;
    }
}
